import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { UserHttpClient } from './user-http-client';
import { UserActions } from './user.store';

@Injectable({ providedIn: 'root' })
export class UserEffects {
  private readonly userService = inject(UserHttpClient);
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  public effects = createEffectFactory(UserActions, this.actions$);

  public fetchCollection$$ = this.effects(UserActions.fetchCollection, () =>
    this.userService.fetchCollection().pipe(map(data => ({ data }))),
  );
}
